import React from "react";
import { FrequentlyAskedQuestionScreen } from "./frequently-asked-question.screen";
import { PrivateRouteDefinition } from "../../../infecto-lms-webapp/router/interfaces";

export const FAQ_SCREEN_PATH = "/faq";
export const FaqRoutes: PrivateRouteDefinition[] = [
	{
		path: FAQ_SCREEN_PATH,
		component: <FrequentlyAskedQuestionScreen />,
	},
];
